/* eslint-disable */
const getters = {
  getCancelOrderReasons(state) {
    return state.data;
  },
};

export default getters;
